import {
    selectedRecordsField,
    updatedRecordsField,
} from 'app/shared-components/BatchActions/BatchUpdate/BatchUpdate.utils'
import {
    UpdateFormFields,
} from 'app/shared-components/BatchActions/BatchUpdate/BatchUpdate.types'
import {
    FieldInCard,
} from 'app/types/form.types'

import {
    FeedbackFormFields,
} from 'app/shared-components/BatchActions/components/UploadFeedback/UploadFeedback.types'
import availableLoggerStatuses from '../Logger/Logger.utils'
import {
    LoggerBatchUpdateFormValues,
    UpdateField,
} from './LoggerBatchUpdate.types'
import {
    updateFieldValues,
} from './LoggerBatchUpdate.utils'

const updateToFieldMap: Record<UpdateField, FieldInCard<keyof LoggerBatchUpdateFormValues>> = {
    [UpdateField.RentingCompany]: {
        name: 'updateTo',
        labelKey: 'UPDATE_TO',
        componentName: 'CompanyObjectSelector',
        useDropdown: true,
        required: true,
    },
    [UpdateField.LoggerStatus]: {
        name: 'updateTo',
        labelKey: 'UPDATE_TO',
        componentName: 'EnumSelector',
        allowedValues: availableLoggerStatuses,
        useDropdown: true,
        required: true,
    },
    [UpdateField.DestinationLocation]: {
        name: 'updateTo',
        labelKey: 'UPDATE_TO',
        componentName: 'LocationObjectSelector',
        required: true,
    },
}

const updateField: FieldInCard<keyof LoggerBatchUpdateFormValues> = {
    name: 'update',
    labelKey: 'UPDATE',
    componentName: 'EnumSelector',
    allowedValues: updateFieldValues,
    useDropdown: true,
    required: true,
}

export const getUpdateFormFields = (
    {
        updateToType,
    }: {
        updateToType: UpdateField | undefined,
    },
): UpdateFormFields<LoggerBatchUpdateFormValues> => {
    const updateToField = updateToFieldMap[updateToType]

    const fields = [
        selectedRecordsField,
        updateField,
    ]

    if (updateToField) {
        fields.push(updateToField)
    }

    return [{
        title: '',
        fields,
    }]
}

export const getFeedbackFormFields = (
    {
        updateToType,
    }: {
        updateToType: UpdateField,
    },
): FeedbackFormFields<LoggerBatchUpdateFormValues> => {
    return [{
        title: '',
        fields: [
            selectedRecordsField,
            updatedRecordsField,
            ...[
                updateField,
                updateToFieldMap[updateToType!],
            ].map((field) => {
                return {
                    ...field, disabled: true,
                }
            }),
        ],
    }]
}
